<template>
	<div>
		<!-- <v-menu v-model="menu" bottom center offset-y origin="top center" transition="scale-transition" :close-on-content-click="false">
			<template v-slot:activator="{ attrs, on }">
				<v-btn class="mt-n2 ml-n2" type="submit" fab small elevation="2" height="30" width="30" @click="menu=true">
					<v-icon>mdi-dots-horizontal</v-icon>
				</v-btn>
			</template>
</v-menu> -->

		<!-- <div v-if="!hideTypesBadge && type === 'NewUserLoan'" style="cursor: pointer;display: inline">
			<v-btn class="mx-1" color="primary" outlined title="پیامک های ثبت پرونده" fab small dark @click="showOperation({ type: 'NewUserLoan', title: 'ثبت پرونده', abbr: 'ج' })">
				<v-icon>mdi-chat-outline</v-icon>
				<v-badge :color="getColor('NewUserLoan')" :content="getCount('NewUserLoan') || '0'" top offset-x="15" offset-y="-7">
				</v-badge>
			</v-btn>
		</div> -->
		<div v-if="!hideTypesBadge" class="app-sms" style="cursor: pointer;display: inline-block;min-width: 60px;">
			<span v-for="t in types.filter(x => x.category === category)" :key="t.type + String(key)" @click="showOperation(t)">
				<v-badge style="" :color="getColor(t.type)" :title="t.title" :content="t.abbr + getCount(t.type)" inline>
				</v-badge>
			</span>
		</div>

		<v-dialog v-model="operationDialog" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">عملیات مورد نظر را انتخاب کنید</span></div>
					<v-spacer />
					<v-btn @click="operationDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<div class="my-3 text-center">
							<v-btn width="200" color="secondary" :disabled="!selectedType.items.length" @click="showDetailsList">مشاهده لیست پیام های ارسال شده</v-btn>
						</div>
						<div class="my-3 text-center" v-if="!selectedType.selectablePattern">
							<v-btn width="250" color="success" dark @click="sendNewSms()" :loading="sendNewSmsLoading">ارسال پیامک {{ selectedType.title }} جدید</v-btn>
						</div>
						<div class="my-3" v-else>
							<v-card color="#eee" elevation="0">
								<v-card-title class="justify-center" style="border-bottom: 1px dashed #d1d1d1;">
									<v-btn width="250" color="success" dark @click="sendNewSms()" :loading="sendNewSmsLoading">ارسال پیامک {{ selectedType.title }} جدید</v-btn>
								</v-card-title>
								<v-card-text>
									<v-row>
										<v-col cols="12">
											<div class="d-flex align-center">
												<v-combobox v-if="patternToggler" v-model="appSettings[selectedType.appSettingsFieldName]" clearable required :rules="[(val) => !!val || 'قالب پیامک را انتخاب کنید']" :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
												<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = selectedType.smsCaregory; dialogSmsPatternManager = true }">
													افرودن قالب
												</v-btn>
											</div>
											<sms-pattern :data="appSettings[selectedType.appSettingsFieldName]" :onlySample="true" />
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</div>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="detailsDialog" scrollable persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست پیامک های {{ selectedType.title }}</span></div>
					<v-spacer />
					<v-btn @click="detailsDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-data-table dense :headers="headers" :loading="detailsListLoading" :items="detailsListItems" :items-per-page="15" class="elevation-1">
							<template v-slot:item.smsPanelText="{ item }">
								{{ translateSmsPanel(item.smsPanelText) }}
							</template>
							<template v-slot:item.statusText="{ item }">
								<div class="d-flex align-center" :class="[statusColor(item.statusText) + '--text']">
									<v-icon :color="statusColor(item.statusText)" small inline class="ml-1">
										{{ statusIcon(item.statusText) }}
									</v-icon>
									<span class="text-h6" style="white-space: nowrap;">{{
										translateStatus(item.statusText) }}</span>
									<v-btn v-if="item.statusText === 'Pending' && item.smsKey" fab icon x-small @click="refreshStatus(item)" :loading="rowLoading == item.id">
										<v-icon>mdi-refresh</v-icon>
									</v-btn>
								</div>
							</template>
							<template v-slot:item.date_Persian="{ item }">
								<div>{{ item.date_Persian.date }}</div>
								<div>{{ item.date_Persian.time }}</div>
							</template>
							<template v-slot:item.text="{ item }">
								<div @click="showSmsMessage(item.text)" style="max-width:250px;overflow:hidden;cursor:pointer;text-overflow: ellipsis;white-space: nowrap;">
									{{ item.text }}
								</div>
							</template>
							<template v-slot:item.appSmsTypeText="{ item }">
								{{ translateType(item) }}
							</template>
							<template v-slot:item.price="{ item }">
								{{ item.price.toString().toPriceFormat() }}
							</template>
							<template v-slot:item.operations="{ item }">
								<v-btn small @click="resend(item)" :loading="rowLoading == item.id">
									ارسال مجدد
								</v-btn>
							</template>
						</v-data-table>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="smsMessageDialog" max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">متن پیامک</span></div>
					<v-spacer />
					<v-btn @click="smsMessageDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<p style="white-space: pre-wrap;">{{ smsMessage }}</p>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSmsPatternManager" scrollable persistent max-width="750px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت قالب های پیامک</span></div>
					<v-spacer />
					<v-btn @click="dialogSmsPatternManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<sms-pattern-manager ref="smsPatternManager" v-if="dialogSmsPatternManager" @itemsUpdated="updatePatterns" :category="selectedCategory" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import { call, get } from 'vuex-pathify'

const CATEGORIES = {
	installments: 'installments',
	userLoan: 'userLoan',
	member: 'member'
}

export default {
	name: 'AppSmsDetails',
	components: {
		'sms-pattern-manager': () => import('@/components/SmsPatternManager.vue'),
		ConfirmDlg: () => import('@/components/Confirm'),
	},
	props: {
		data: {
			type: Array,
		},
		entityId: {
			type: String
		},
		type: {
			type: String
		},
		category: {
			type: String,
			default: CATEGORIES.installments
		},
		hideTypesBadge: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		categories: CATEGORIES,
		dialogSmsPatternManager: false,
		key: 1,
		menu: false,
		localData: [],
		detailsListItems: [],
		detailsListLoading: false,
		rowLoading: '',
		smsMessage: '',
		smsMessageDialog: false,
		sendNewSmsLoading: false,
		operationDialog: false,
		detailsDialog: false,
		selectedType: { title: '', items: [], type: '' },
		selectedCategory: 0,
		errorMessages: '',
		appSettings: { dashboardSettings: {} },
		smsPatterns: [],
		loading: false,
		tempAppSettingsPattern: null,
		patternToggler: true,
		types: [{
			type: 'BeforeDueDate',
			title: 'پیش از موعد',
			abbr: 'پ',
			category: CATEGORIES.installments
		},
		{
			type: 'DueDate',
			title: 'سررسید',
			abbr: 'س',
			category: CATEGORIES.installments
		},
		{
			type: 'OverDueDate',
			title: 'معوق',
			abbr: 'م',
			category: CATEGORIES.installments
		},
		{
			type: 'Thanks',
			title: 'تشکر',
			abbr: 'ت',
			category: CATEGORIES.installments
		},
		{
			type: 'ChangeStatus',
			title: 'تغییر وضعیت درخواست',
			abbr: ''
		},
		{
			type: 'ChangeAgentStatus',
			title: 'تغییر وضعیت درخواست نماینده',
			abbr: ''
		},
		{
			type: 'WalletCharge',
			title: 'لینک شارژ کیف پول',
			abbr: 'ل',
			category: CATEGORIES.member,
			selectablePattern: true,
			smsCaregory: 5,
			url: 'admin/AppSms/SendWalletCharge',
			appSettingsFieldName: 'walletChargeSmsPattern',
			autoUpdateAppSettings: true
		},
		{
			type: 'Register',
			title: 'خوش آمد ثبت نام',
			abbr: 'خ',
			category: CATEGORIES.member,
			selectablePattern: true,
			smsCaregory: 3,
			url: 'admin/AppSms/SendWelcomeRegister',
			appSettingsFieldName: 'registerSmsPattern'
		},
		{
			type: 'NewUserLoan',
			title: 'ثبت پرونده',
			abbr: 'ج',
			category: CATEGORIES.userLoan,
			url: 'admin/appsms/SendForUserLoan',
			selectablePattern: true,
			smsCaregory: 7,
			appSettingsFieldName: 'newUserLoanSmsPattern',
			autoUpdateAppSettings: true
		}
		],
		headers: [
			{
				text: 'پنل پیامک',
				align: 'right',
				sortable: true,
				value: 'smsPanelText',
			},
			{
				text: 'وضعیت',
				align: 'center',
				sortable: true,
				value: 'statusText',
			},
			{
				text: 'زمان ارسال',
				align: 'center',
				sortable: true,
				value: 'date_Persian',
			}, {
				text: 'متن',
				align: 'right',
				sortable: true,
				value: 'text',
				width: 200
			}, {
				text: 'دریافت کننده',
				align: 'center',
				sortable: true,
				value: 'to',
			}, {
				text: 'نوع',
				align: 'center',
				sortable: true,
				value: 'appSmsTypeText',
			}, {
				text: 'عملیات',
				align: 'center',
				sortable: false,
				value: 'operations',
			}
		],
	}),
	watch: {
		data: {
			deep: true,
			handler(val) {
				this.localData = [...(val || [])]
				if (this.type !== 'ChangeStatus' && this.selectedType)
					this.selectedType.items = this.localData.filter(x => x.appSmsTypeText === this.selectedType.type)
				else if (this.type === 'ChangeStatus')
					this.selectedType.items = [...this.localData]
			}
		}
	},
	created() {
		this.localData = [...(this.data || [])]
		if (this.type === 'ChangeStatus') {
			this.selectedType = {
				type: 'ChangeStatus',
				title: 'تغییر وضعیت درخواست',
				items: [...this.localData]
			}
		}
	},
	mounted() {

	},
	methods: {
		...call('appSettings/*'),
		saveSmsSettings() {
			this.loading = true
			var data = _.cloneDeep(this.appSettings)
			data[this.selectedType.appSettingsFieldName].category = data[this.selectedType.appSettingsFieldName].category?.value || data[this.selectedType.appSettingsFieldName].category
			this.sync(data).then(x => {
				this.loading = false
				toast.success('اطلاعات با موفقیت ذخیره شد.')
			}).catch(err => {
				this.loading = false
				toast.error(err.message)
			})
		},
		loadAppSettings() {
			this.fetch({ force: true }).then(x => {
				this.appSettings = x
				this.tempAppSettingsPattern = this.appSettings.newUserLoanSmsPattern ? { ...this.appSettings.newUserLoanSmsPattern } : null
			})
		},
		loadSmsPatterns() {
			api.get('admin/smsPattern/list', null)
				.then(
					response => {
						this.smsPatterns = response.filter(x => x.status === 1 && x.category === this.selectedType.smsCaregory)
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
				})
		},
		updatePatterns(items) {
			this.dialogSmsPatternManager = false
			this.patternToggler = false
			setTimeout(() => {
				this.smsPatterns = items.filter(x => x.status === 1 && x.category === this.selectedCategory)
				this.patternToggler = true
			}, 200)
		},
		getColor(type) {
			if (!this.localData?.filter(x => x.appSmsTypeText === type)?.length)
				return 'grey'
			if (this.localData?.filter(x => x.appSmsTypeText === type && x.statusText === 'Delivered')?.length > 0)
				return 'success'
			if (this.localData?.filter(x => x.appSmsTypeText === type && x.statusText === 'Pending')?.length > 0)
				return 'warning'
			return 'error'
		},
		getCount(type) {
			let count = this.localData?.filter(x => x.appSmsTypeText === type)?.length
			if (!count || count === 1)
				return ''
			return ` (${count})`
		},
		showOperation(type) {
			this.selectedType = type
			this.selectedType.items = this.localData.filter(x => x.appSmsTypeText === type.type)
			this.operationDialog = true
			if (type.selectablePattern) {
				this.loadAppSettings()
				if (!this.smsPatterns?.length)
					this.loadSmsPatterns()
			}
		},
		showOperationByTypeName(type) {
			let t = this.types.find(x => x.type === type)
			if (!t)
				return
			this.showOperation(t)
		},
		async sendNewSms() {
			if (this.selectedType.autoUpdateAppSettings && this.tempAppSettingsPattern?.id !== this.appSettings[this.selectedType.appSettingsFieldName]?.id) {
				await this.saveSmsSettings()
			}

			this.sendNewSmsLoading = true
			const url = this.selectedType.url || 'admin/appsms/SendForUserLoanPayment'
			api.post(`${url}/?id=` + this.entityId + '&type=' + this.selectedType.type, null)
				.then(response => {
					toast.success('پیامک ارسال شد.')
					this.operationDialog = false
					this.localData.push(response)
					this.key++
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.sendNewSmsLoading = false
				})
		},
		loadSmsDetailsList() {
			this.detailsListLoading = true
			api.post('admin/appsms/ListByIds', { ids: this.selectedType.items.map(x => x.id) })
				.then(
					response => {
						this.detailsListItems = response
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
					this.detailsListLoading = false
				})
		},
		translateType(item) {
			if (item.appSmsType == 0)
				return item.smsPatternTitle

			let translates = {
				'Unknown': 'متفرقه',
				'DueDate': 'یادآوری سررسید',
				'Thanks': 'تشکر از پرداخت',
				'OverDueDate': 'معوق',
				'BeforeDueDate': 'یادآوری پیش از موعد',
				'ChangeStatus': 'تغییر وضعیت درخواست وام',
				'ChangeAgentStatus': 'تغییر وضعیت نماینده',
				'VerifyCode': 'کد تاییدیه',
				'Login': 'ورود به پنل',
				'Register': 'خوش آمد ثبت نام',
				'WalletCharge': 'شارژ کیف پول',
				'LoginOTP': 'رمز عبور پیامکی',
				'DailyReport': 'گزارش روزانه به مدیر',
				'NewOrder': 'سفارش خرید اقساطی به مدیر',
				'NewUserLoan': 'ثبت پرونده'
			}
			return translates[item.appSmsTypeText] || 'نامشخص'
		},
		translateStatus(status) {
			let items = {
				'Pending': 'منتظر وضعیت',
				'Delivered': 'تحویل شده',
				'Failed': 'تحویل نشده',
			}
			return items[status] || 'نامشخص'
		},
		statusColor(status) {
			let items = {
				'Pending': 'warning',
				'Delivered': 'success',
				'Failed': 'error',
			}
			return items[status] || 'grey'
		},
		statusIcon(status) {
			let items = {
				'Pending': 'mdi-timer-sand',
				'Delivered': 'mdi-check-circle',
				'Failed': 'mdi-close-circle',
			}
			return items[status] || 'mdi-exclamation'
		},
		showSmsMessage(text) {
			this.smsMessage = text
			this.smsMessageDialog = true
		},
		async resend(item) {
			if (await this.$refs.confirm.open(
				'توجه',
				'آیا از ارسال مجدد این پیامک مطمئن هستید؟',
			)) {
				this.rowLoading = item.id
				api.post('admin/appsms/ReSend/' + item.id, null)
					.then(response => {
						toast.success('پیامک ارسال شد.')
						this.loadSmsDetailsList()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.rowLoading = ''
					})
			}
		},
		showDetailsList() {
			this.detailsListItems = []
			this.detailsDialog = true
			if (this.selectedType?.items.length)
				this.loadSmsDetailsList()
		},
		translateSmsPanel(panel) {
			let items = {
				'Unknown': 'نامشخص',
				'JetAqsaat_MelliPayamak': 'جت اقساط',
				'JetAqsaat_KaveNegar': 'جت اقساط',
				'JetAqsaat_IPPanel': 'جت اقساط',
				'JetAqsaat': 'جت اقساط',
				'MelliPayamak': 'ملی پیامک',
				'KaveNegar': 'کاوه نگار',
				'IPPanel': 'IPPanel',
				'Bale': 'پیام رسان بله',
			}
			return items[panel] || 'نامشخص'
		},
		refreshStatus(item) {
			this.rowLoading = item.id
			api.post('admin/appsms/CheckStatus/' + item.id, null)
				.then(response => {
					item.statusText = response
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.rowLoading = ''
				})
		}
	}
}
</script>
<style>
.detial-box .title {
	font-size: 11px;
	color: grey;
}

.detial-box .value {
	font-size: 11px;
	color: black;
}

.app-sms .v-badge--inline .v-badge__wrapper {
	margin: 0 1px !important;
}
</style>